



























































import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import uuifComponent from '@/shared/uuifComponent';
import { Component, Prop } from 'vue-property-decorator';
import { SwModal, SwModalBody, SwModalFooter } from '@sonicwall/unified-ui-framework/src/shared/sw-modal';
import { SwTextarea } from '@sonicwall/unified-ui-framework/src/shared/sw-textfield';
import { InfoState } from '@/core';

@Component({
  components: {
    ...uuifComponent,
    SwModal,
    SwModalBody,
    SwModalFooter,
    SwTextarea,
  },
})

export default class RequestChangeModal extends SwExtendedVue {
  @Prop()
  quoteId: string;
  @Prop()
  isRequestChangeModal: boolean;

  requestText:any = '';
  isRequestTextError: boolean = false;
  cancel() {
    this.requestText = '';
  }
  changeRequest() {
    if (this.requestText !== '') {
      const request = {
        equoteId: this.quoteId,
        remarks: this.requestText,
      };
      this.$store
      .dispatch('SnbQuotesStoreModule/requestChange', request)
      .then((res:any) => {
        this.$store.commit('stopLoading');
        if (res.msgCode === 'MSWAPP:UPDATEQUOTE') {
          const message: InfoState = {
            infoType: 'success',
            infoMsg: res.msgDesc,
          };
          this.$emit('closeModal');
          this.$store.commit('displayMessage', message);
        }
      });
    } else {
      this.isRequestTextError = true;
    }
  }
  closeDialog() {
    this.$emit('closeModal');
  }
}
